import { axiosInstance } from './baseApi';

const cloudApi = {
  getAccounts: (token) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/Accounts`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAvailableActions: (token) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAvailableActions`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAllowedReportKeys: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetAllowedReportKeys`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
      },
    }),

  getReportPermissionMatrix: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetReportPermissionMatrix`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
      },
    }),

  saveReportPermissionMatrix: (token, accountId, rows) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/SaveReportPermissionMatrix`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        rows,
      },
    }),

  resetReportPermissionMatrix: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/ResetReportPermissionMatrix`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
      },
    }),

  createAccount: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/CreateAccount`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getAccountDetails: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAccountDetails/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  updateAccountDomain: (token, accountId, domain) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateAccountDomain`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        domain: domain,
      },
    }),

  updateAccountBrandingLinks: (token, accountId, logoPath, resellerLogoPath) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateAccountBrandingLinks`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        logoPath,
        resellerLogoPath,
      },
    }),

  getSitesMetadata: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/GetSitesMetadata/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getSite: (token, siteId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/GetSite/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getSiteDashboardImage: (token, siteId, cacheBuster = Date.now()) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/GetSiteDashboardImage/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
      params: { v: cacheBuster },
      responseType: 'blob',
    }),

  uploadSiteDashboardImage: (token, siteId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/UploadSiteDashboardImage/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: formData,
    });
  },

  clearSiteDashboardImage: (token, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/ClearSiteDashboardImage/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAccountGates: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/GetAccountGates/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAccountSites: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/GetAccountSites/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAccountGroupsAndMembers: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/User/GetAccountGroupsAndMembers/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  // Accept optional axios config (e.g., { signal }) for cancellation
  getAccountMembers: (token, accountId, config = {}) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/User/GetAccountMembers/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      ...config,
    }),

  getOverviewData: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Monitoring/GetOverviewData`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
      }
    }),

  getEnhancedOverviewData: (token, accountId, dateRange = 'today') =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Monitoring/GetEnhancedOverviewData`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        dateRange: dateRange,
      }
    }),

  inviteUser: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/User/InviteUser`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  updateUserGroups: (token, userId, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/User/UpdateUserGroups/${userId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getDashboardData: (token, accountId, activityPageSize, activityPage, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Monitoring/GetDashboardData`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        activityPageSize: 10000,
        activityPage: 1,
        siteId: siteId,
      }
    }),

  getAnomalyReport: (token, from, to, accountId, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetAnomalyReport`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        from: from,
        to: to,
        accountId: accountId,
        siteId: siteId
      }
    }),

  getExpiringProfilesAndCertificates: (token, accountId, siteId, daysBeforeExpiry = 30) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetExpiringProfilesAndCertificates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId: accountId,
        siteId: siteId,
        daysBeforeExpiry: daysBeforeExpiry
      }
    }),

  getPeopleOnSiteFromTracking: (token, from, to, accountId, siteId, options = {}) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetPeopleOnSiteFromTracking`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        from: from,
        to: to,
        accountId: accountId,
        siteId: siteId,
        companyName: (() => {
          const rawCompanyName = typeof options.companyName === 'string'
            ? options.companyName.trim()
            : options.companyName;
          if (!rawCompanyName) {
            return null;
          }

          return rawCompanyName.toLowerCase() === 'all'
            ? null
            : rawCompanyName;
        })(),
      }
    }),

  getMusterReportSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ReportsSettings/GetMusterReportSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  updateMusterReportSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ReportsSettings/UpdateMusterReportSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  deleteMusterReportSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ReportsSettings/DeleteMusterReportSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getDailyProfilesReportSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ReportsSettings/GetDailyProfilesReportSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  updateDailyProfilesReportSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ReportsSettings/UpdateDailyProfilesReportSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getCompanyTimeAndAttendanceList: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetCompanyTimeAndAttendanceList`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getCompanyTimeAndAttendanceListForGroupReport: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/getCompanyTimeAndAttendanceListForGroupReport`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getTimeAndAttendance: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetTimeAndAttendance`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getBoscaAdminDailySiteAttendance: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetBoscaAdminDailySiteAttendance`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getBoscaAdminDailyProfilePresenceSummary: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetBoscaAdminDailyProfilePresenceSummary`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getBoscaAdminDailyProfilePresenceMatrix: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetBoscaAdminDailyProfilePresenceMatrix`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getBoscaAdminDailyProfilePresenceDayDetail: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetBoscaAdminDailyProfilePresenceDayDetail`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getSiteProfilePipelineSideBySide: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetSiteProfilePipelineSideBySide`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getProfileTimeAndAttendance: (token, from, to, accountId, profileId, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetProfileTimeAndAttendance`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        from: from,
        to: to,
        accountId: accountId,
        profileId: profileId,
        ...(siteId ? { siteId } : {}),
      }
    }),

  getEvents: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetEvents`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getEventStats: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetEventStats`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  createSiteGroup: (token, siteId, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/CreateSiteGroup/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getCompanyTimeAndAttendanceFromTracking: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetCompanyTimeAndAttendanceFromTracking`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getCompanyGroups: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ContractingCompany/${accountId}/groups`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  saveCompanyGroups: (token, accountId, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/ContractingCompany/${accountId}/groups`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  updateSiteGateGroup: (token, gateId, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/UpdateGateGroup/${gateId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        path: siteId
      }
    }),

  createSkillkoConnection: (token, { accountId, clientId, secret, refreshToken, tenantId }) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/CreateSkillkoConnection`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        clientId,
        secret,
        refreshToken,
        tenantId,
      }
    }),

  updateSkillkoRefreshToken: (token, { accountId, skillkoAccountId, refreshToken }) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateSkillkoRefreshToken`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        skillkoAccountId,
        refreshToken,
      }
    }),

  getSkillkoConnections: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetSkillkoConnections/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getAccountSkillkoFlags: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAccountSkillkoFlags/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  updateAccountSkillkoFlags: (token, accountId, flags) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateAccountSkillkoFlags`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        ...flags,
      }
    }),

  initSkillko: (token, accountId, siteId = null) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/InitSkillko`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        ...(siteId ? { siteId } : {}),
      }
    }),

  forceUpdateAllBoxExpiry: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ForceUpdateAllBoxExpiry`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId
      }
    }),

  testRunImportWorker: (token, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/TestRunImportWorker`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId
      }
    }),

  getAccountSitePassFlags: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAccountSitePassFlags/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  updateAccountSitePassFlags: (token, accountId, flags) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateAccountSitePassFlags`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        ...flags,
      }
    }),

  getAccountProcoreFlags: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAccountProcoreFlags/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  updateAccountProcoreFlags: (token, accountId, flags) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateAccountProcoreFlags`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        ...flags,
      }
    }),

  getAccountKeys: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetKeys/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  generateAccountKey: (token, accountId, expireAfter) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GenerateKey`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        expireAfter,
      }
    }),

  getIntegrationKeys: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetIntegrationKeys/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  generateIntegrationKey: (token, accountId, expireAfter, scope) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GenerateIntegrationKey`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        expireAfter,
        scope,
      }
    }),

  getWinthropSettings: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetWinthropSettings/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  updateWinthropSettings: (token, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/UpdateWinthropSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data,
    }),

  getSkillkoTeams: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoTeams`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSkillkoTeamCertificates: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoTeamCertificates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSkillkoCertificatesForAccount: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoCertificatesForAccount`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  switchSkillkoTeamActivity: (token, { accountId, skillkoId }) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/SwitchSkillkoTeam`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        skillkoId
      }
    }),

  // Skillko Health Check APIs
  forceSyncSkillkoProfile: (token, accountId, skillkoId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ForceSyncSkillkoProfile`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        skillkoId
      }
    }),

  forceUpdateRegisteredProfileFromSkillko: (token, { accountId, siteId, profileId }) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ForceUpdateRegisteredProfileFromSkillko`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        accountId,
        siteId,
        profileId
      }
    }),

  linkSiteProfileToSkillko: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/LinkSiteProfileToSkillko`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSkillkoMergeCandidates: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoMergeCandidates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  getSkillkoProfileHealthCheck: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoProfileHealthCheck`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  forceSyncSkillkoTeam: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/ForceSyncSkillkoTeam`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSkillkoCertificateHealthCheckByProfile: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoCertificateHealthCheckByProfile`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSkillkoCertificateHealthCheckFlat: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Induction/GetSkillkoCertificateHealthCheckFlat`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getRulesForSite: (token, siteId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/GetRulesForSite?siteId=${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }
    }),

  getRuleById: (token, ruleId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/GetRuleById?ruleId=${ruleId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }
    }),

  createRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/CreateRule`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  updateRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/UpdateRule`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  deleteRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/DeleteRule`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  validateRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/ValidateRule`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  refreshRulesForSite: (token, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/RefreshRulesForSite?siteId=${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }
    }),

  // Expiry Rule APIs
  getExpiryRuleForTeamSite: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/GetExpiryRuleForTeamSite`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getExpiryRulesForSite: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/GetExpiryRulesForSite`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  deleteExpiryRulesForSite: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/DeleteExpiryRulesForSite`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  createOrUpdateExpiryRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/CreateOrUpdateExpiryRule`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  deleteExpiryRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/DeleteExpiryRule`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  validateExpiryRule: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/ValidateExpiryRule`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  enableAutoExpiryForSite: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/EnableAutoExpiryForSite`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  // Skillko Auto-Induction settings (per site)
  getAutoInductionSettingsForSite: (token, { siteId, accountId }) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/GetAutoInductionSettingsForSite?siteId=${siteId}&accountId=${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      }
    }),

  updateAutoInductionSettingsForSite: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/InductionRule/UpdateAutoInductionSettingsForSite`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getSiteDoors: async (token, siteId, accountId) => {
    return await axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Door/GetSiteDoorControllers`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      },
    });
  },

  openAllDoors: async (token, siteId, accountId) => {
    return await axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Door/RollCallOpenAllGatesOnSite`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      },
    });
  },

  resetAllDoors: async (token, siteId, accountId) => {
    return await axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Door/RollCallCloseAllGatesOnSite`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      },
    });
  },

  openDoor: async (token, siteId, accountId, doorId, relay) => {
    return await axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Door/TimedOpenDoorRelay`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        doorId: doorId,
        relay: relay,
        openTimeInMilliseconds: 15000, // 15 seconds
      },
    });
  },

  // EventGenerator API endpoints
  getEventGenerationInfo: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/EventGenerator/GetGenerationInfo`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      }
    }),

  generateEvents: (token, siteId, accountId, eventGenerationRequest) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/EventGenerator/GenerateEvents`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        eventGenerationRequest: eventGenerationRequest,
      }
    }),

  generateQuickEvents: (token, siteId, accountId, count = 100) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/EventGenerator/GenerateQuickEvents`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        count: count,
      }
    }),

  // Face Scanner Device API endpoints
  getFaceScannerConnectedDevices: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetConnectedDevices`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      }
    }),

  getFaceScannerEnrolledUsers: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetEnrolledUsers`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  getFaceScannerUserDetails: (token, siteId, accountId, deviceId, userIds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetUserDetails`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
        userIds: userIds,
      }
    }),

  deleteFaceScannerUser: (token, siteId, accountId, deviceId, userId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/DeleteUserFromDevice`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
        userId: userId,
      }
    }),

  getFaceScannerDeviceAccessLevels: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetDeviceAccessLevels`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  setFaceScannerUserAccessGroups: (token, siteId, accountId, deviceId, userId, accessGroupIds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/SetUserAccessGroups`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
        userId: userId,
        accessGroupIds: accessGroupIds,
      }
    }),

  // Device Settings API endpoints
  getWiegandConfig: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetWiegandConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  setWiegandConfig: (token, siteId, accountId, config) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/SetWiegandConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        config: config,
      }
    }),

  getIPConfig: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetIPConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  setIPConfig: (token, siteId, accountId, config) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/SetIPConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        config: config,
      }
    }),

  getWLANConfig: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetWLANConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  setWLANConfig: (token, siteId, accountId, config) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/SetWLANConfig`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        config: config,
      }
    }),

  renameFaceScannerDevice: (token, siteId, accountId, deviceId, name) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/RenameDevice`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        config: {
          deviceId: deviceId,
          name: name,
        },
      }
    }),

  getFaceScannerDeviceNames: (token, siteId, accountId, deviceIds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetDeviceNames`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceIds: deviceIds,
      }
    }),

  getFaceScannerTimeSettings: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/GetTimeSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  setFaceScannerTimeSettings: (token, siteId, accountId, config) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerDevice/SetTimeSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        config: config,
      }
    }),

  getRelayStatus: (token, siteId, accountId, deviceId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerRelay/GetRelayStatus`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
      }
    }),

  configureRelay: (token, siteId, accountId, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerRelay/ConfigureRelay`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: payload.deviceId,
        isActive: payload.isActive,
        openTimeSeconds: payload.openTimeSeconds ?? null,
        name: payload.name ?? null,
      }
    }),

  pulseRelay: (token, siteId, accountId, deviceId, durationSeconds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerRelay/PulseRelay`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
        durationSeconds: durationSeconds ?? null,
      }
    }),

  deleteFaceScannerDoors: (token, siteId, accountId, deviceId, doorIds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerRelay/DeleteDoors`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        deviceId: deviceId,
        doorIds: doorIds ?? null,
      }
    }),

  // Face Scanner Gate API endpoints
  getFaceScannerGateGroups: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/GetGateGroups`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      }
    }),

  getFaceScannerGates: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/GetGates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
      }
    }),

  createFaceScannerGateGroup: (token, siteId, accountId, name) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/CreateGateGroup`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        name: name,
      }
    }),

  updateFaceScannerGateGroup: (token, siteId, accountId, id, name) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/UpdateGateGroup`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: id,
        name: name,
      }
    }),

  deleteFaceScannerGateGroup: (token, siteId, accountId, id) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/DeleteGateGroup`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: id,
      }
    }),

  createFaceScannerGate: (token, siteId, accountId, gate) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/CreateGate`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        name: gate.name,
        inDeviceIds: gate.inDeviceIds,
        outDeviceIds: gate.outDeviceIds,
        gateGroupId: gate.gateGroupId,
        correlationId: gate.correlationId ?? null,
      }
    }),

  renameFaceScannerGate: (token, siteId, accountId, gate) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/RenameGate`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: gate.id,
        name: gate.name,
        correlationId: gate.correlationId ?? null,
      }
    }),

  moveFaceScannerGate: (token, siteId, accountId, gate) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/MoveGate`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: gate.id,
        gateGroupId: gate.gateGroupId,
        correlationId: gate.correlationId ?? null,
      }
    }),

  replaceFaceScannerGateDevices: (token, siteId, accountId, gate) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/ReplaceGateDevices`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: gate.id,
        inDeviceIds: gate.inDeviceIds,
        outDeviceIds: gate.outDeviceIds,
        correlationId: gate.correlationId ?? null,
      }
    }),

  deleteFaceScannerGate: (token, siteId, accountId, id) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/DeleteGate`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        id: id,
      }
    }),

  configureFaceScannerApbZone: (token, siteId, accountId, groupId, hardMode, resetDurationSeconds) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/ConfigureApbZone`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        groupId: groupId,
        hardMode: hardMode,
        resetDurationSeconds: resetDurationSeconds ?? null,
      }
    }),

  removeFaceScannerApbZone: (token, siteId, accountId, groupId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/FaceScannerGate/RemoveApbZone`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        siteId: siteId,
        accountId: accountId,
        groupId: groupId,
      }
    }),

  // Device Display API endpoints
  pushWallpaperToDevices: (token, requestData, onUploadProgress) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/DeviceDisplay/PushWallpaper`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      data: requestData,
      onUploadProgress: onUploadProgress,
    }),

  pushScreensaverToDevices: (token, requestData, onUploadProgress) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/DeviceDisplay/PushScreensaver`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      data: requestData,
      onUploadProgress: onUploadProgress,
    }),

  clearSiteData: (token, siteId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Site/ClearSiteData/${siteId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  getFirstInLastOutReport: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetFirstInLastOutReport`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getProfileDayActivities: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Reports/GetProfileDayActivities`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  // Audit Trail
  getAuditTrail: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/Account/GetAuditTrail`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload
    }),

  getTenantSettings: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/TenantSettings/GetTenantSettings`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  upsertTenantSetting: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/TenantSettings/UpsertTenantSetting`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  deleteTenantSetting: (token, payload) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/TenantSettings/DeleteTenantSetting`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: payload,
    }),

  // Box Management -- Event Sync
  getEventSyncStatus: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/GetEventSyncStatus`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  enableEventSync: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/EnableEventSync`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  disableEventSync: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/DisableEventSync`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  resetImportState: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ResetImportState`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  // Box Management -- Import Operations
  importProfilesFromDoorController: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportProfilesFromDoorController`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  importProfilesFromFaceScanner: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportProfilesFromFaceScanner`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  importAccessLevelsFromDoorController: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportAccessLevelsFromDoorController`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  importAccessLevelsFromFaceScanner: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportAccessLevelsFromFaceScanner`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  importDoorsFromDoorController: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportDoorsFromDoorController`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  importDevicesFromFaceScanner: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/BoxManagement/ImportDevicesFromFaceScanner`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  // Access Level Designer
  fetchAccessLevelsFromDevices: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/AccessLevelDesigner/FetchFromDevices`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  getAccessLevelAreas: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/AccessLevelDesigner/GetAreas`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  getAccessLevelGates: (token, siteId, accountId) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/AccessLevelDesigner/GetGates`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId },
    }),

  pushAccessLevelToDevice: (token, siteId, accountId, contract, targetType, areaIds = []) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/AccessLevelDesigner/PushToDevice`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { siteId, accountId, contract, targetType, areaIds },
    }),
};

export default cloudApi;
